import regionAccountRepository from '@/repositories/regionAccount.repository';

class RegionAccountService {
  async saveRegionAccountInfo (params) {
    const data = await regionAccountRepository.saveRegionAccount(params);
    return data || [];
  }
  async findRegionAccountByConditions (params) {
    const data = await regionAccountRepository.findRegionAccountByConditions(params);
    return data || [];
  }
  async findSearchConditions () {
    const data = await regionAccountRepository.findSearchConditions();
    return data || [];
  }
  async findAllActiveDisplayNames () {
    const data = await regionAccountRepository.findAllActiveDisplayNames();
    return data || []
  }
  async findAllDataByConditions (params) {
    const data = await regionAccountRepository.findAllDataByConditions(params);
    return data || [];
  }
  async findAll () {
    const data = await regionAccountRepository.findAll();
    return data || [];
  }
}
module.exports = new RegionAccountService();



// WEBPACK FOOTER //
// ./src/services/regionAccount.service.js